import { ca } from '@cian/analytics';

export function trackComplaintClick() {
  ca('event', {
    name: 'oldevent',
    action: 'click_complain',
    category: 'ListingFavorites',
    label: '',
  });
}

export function trackComplaintSend() {
  ca('event', {
    name: 'oldevent',
    action: 'send_complain',
    category: 'ListingFavorites',
    label: '',
  });
}
